/**
 * トップページ専用 ScrollTrigger アニメーション
 */

// ============================================================
// ABOUT セクション
// ============================================================
const initAbout = () => {
  const section = document.querySelector('.p-top-about');
  if (!section) return;

  const textEl = section.querySelector('.p-top-about__text');
  const imageEl = section.querySelector('.p-top-about__image');
  const imageInner = section.querySelector('.p-top-about__image-inner');

  // テキスト：スクロールに連動して左からスライドイン
  gsap.fromTo(
    textEl,
    { x: -80, opacity: 0 },
    {
      x: 0,
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 90%',
        end: 'top 20%',
        scrub: 1,
      },
    },
  );

  // 写真：スクロールに連動して右からスライドイン
  gsap.fromTo(
    imageEl,
    { x: 80, opacity: 0 },
    {
      x: 0,
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 90%',
        end: 'top 20%',
        scrub: 1,
      },
    },
  );

  // 写真 Ken Burns（ゆっくり拡大縮小ループ）
  if (imageInner) {
    gsap.fromTo(
      imageInner,
      { scale: 1 },
      {
        scale: 1.08,
        duration: 10,
        ease: 'none',
        repeat: -1,
        yoyo: true,
      },
    );
  }
};

// ============================================================
// SERVICE セクション（100vh ピン + スクラブ、左右交互スライドイン）
// ============================================================
const initService = () => {
  const section     = document.querySelector('.p-top-service:not(.p-top-service--sub)');
  if (!section) return;

  const headerInner = section.querySelector('.p-top-service__header-inner');
  const cards       = Array.from(section.querySelectorAll('.p-top-service__card'));

  const mm = gsap.matchMedia();

  // ── デスクトップ：ピン留め + スクラブ ──
  mm.add('(min-width: 992px)', () => {
    const CARD_DUR    = 0.22;  // 1ガシャンのアニメ尺（遅め）
    const GAP_BETWEEN = 0.30;  // ガシャン間のホールド（約1スクロール分）
    const GAP_AFTER   = 1.5;   // 全部出揃った後のホールド

    const tl = gsap.timeline({ paused: true });

    gsap.set([headerInner, ...cards], { willChange: 'transform, opacity' });
    gsap.set(headerInner, { x: -50, opacity: 0 });

    // 左列(偶数index) → 左から、右列(奇数index) → 右から
    cards.forEach((card, i) => {
      gsap.set(card, { x: i % 2 === 0 ? -120 : 120, opacity: 0 });
    });

    // ヘッダー入場
    tl.to(headerInner, { x: 0, opacity: 1, duration: 0.10, ease: 'none' }, 0);

    // カード：行ごとに左右同時（ガシャン） → ホールド → 次の行
    // ヘッダー表示後に 0.55 のホールドを挟んでからカードを開始
    const rows = Math.ceil(cards.length / 2);
    let cursor = 0.65;   // 0.10(header) + 0.55(hold) = カード開始位置
    let lastRowEnd = cursor;

    for (let row = 0; row < rows; row++) {
      const left  = cards[row * 2];
      const right = cards[row * 2 + 1];
      if (left)  tl.to(left,  { x: 0, opacity: 1, duration: CARD_DUR, ease: 'none' }, cursor);
      if (right) tl.to(right, { x: 0, opacity: 1, duration: CARD_DUR, ease: 'none' }, cursor);
      lastRowEnd = cursor + CARD_DUR;
      cursor = lastRowEnd + GAP_BETWEEN; // 次の行まで間を置く
    }

    // 最後のガシャン後にホールド
    tl.to({}, { duration: GAP_AFTER }, lastRowEnd);

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: '+=3800',
      pin: true,
      scrub: 1.5,
      animation: tl,
    });

    return () => {
      gsap.set([headerInner, ...cards], { clearProps: 'all', willChange: 'auto' });
    };
  });

  // ── モバイル：ピン留め + スクラブ（PC と同じ動き）──
  mm.add('(max-width: 991px)', () => {
    const CARD_DUR    = 0.22;
    const GAP_BETWEEN = 0.30;
    const GAP_AFTER   = 1.0;

    const tl = gsap.timeline({ paused: true });

    gsap.set([headerInner, ...cards], { willChange: 'transform, opacity' });
    gsap.set(headerInner, { x: -50, opacity: 0 });
    cards.forEach((card, i) => {
      gsap.set(card, { x: i % 2 === 0 ? -80 : 80, opacity: 0 });
    });

    tl.to(headerInner, { x: 0, opacity: 1, duration: 0.10, ease: 'none' }, 0);

    const rows = Math.ceil(cards.length / 2);
    let cursor = 0.65;   // 0.10(header) + 0.55(hold) = カード開始位置
    let lastRowEnd = cursor;
    for (let row = 0; row < rows; row++) {
      const left  = cards[row * 2];
      const right = cards[row * 2 + 1];
      if (left)  tl.to(left,  { x: 0, opacity: 1, duration: CARD_DUR, ease: 'none' }, cursor);
      if (right) tl.to(right, { x: 0, opacity: 1, duration: CARD_DUR, ease: 'none' }, cursor);
      lastRowEnd = cursor + CARD_DUR;
      cursor = lastRowEnd + GAP_BETWEEN;
    }
    tl.to({}, { duration: GAP_AFTER }, lastRowEnd);

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: '+=2400',
      pin: true,
      scrub: 1.5,
      animation: tl,
    });

    return () => {
      gsap.set([headerInner, ...cards], { clearProps: 'all', willChange: 'auto' });
    };
  });
};

// ============================================================
// WORKS セクション（100vh ピン + スクラブ）
// ============================================================
const initWorks = () => {
  const section = document.querySelector('.p-top-works');
  if (!section) return;

  const headerInner = section.querySelector('.p-top-works__header-inner');
  const headerLine  = section.querySelector('.p-top-works__header-line');
  const cards       = Array.from(section.querySelectorAll('.p-top-works__card'));
  const footer      = section.querySelector('.p-top-works__footer');

  const mm = gsap.matchMedia();

  // ── デスクトップ：ピン留め + スクラブ ──
  mm.add('(min-width: 992px)', () => {
    const HOLD     = 0.10;
    const STEP     = 0.20;
    const CARD_DUR = 0.16;

    const tl = gsap.timeline({ paused: true });

    // GPU レイヤー昇格
    gsap.set([headerInner, headerLine, ...cards, footer].filter(Boolean), {
      willChange: 'transform, opacity, clip-path',
    });

    // 初期状態
    gsap.set(headerInner, { x: -50, opacity: 0 });
    gsap.set(headerLine,  { scaleX: 0 });
    gsap.set(cards,       { clipPath: 'inset(100% 0 0% 0)', opacity: 0 });
    gsap.set(footer,      { opacity: 0, y: 16 });

    // ヘッダー入場
    tl.to(headerInner, { x: 0, opacity: 1, duration: 0.10, ease: 'none' }, 0);

    // HUD ライン
    tl.to(headerLine,  { scaleX: 1, duration: 0.08, ease: 'none' }, 0.06);

    // カード：ボトムアップワイプ（データロード風）
    cards.forEach((card, i) => {
      tl.to(
        card,
        { clipPath: 'inset(0% 0 0% 0)', opacity: 1, duration: CARD_DUR, ease: 'none' },
        HOLD + i * STEP,
      );
    });

    // フッター
    const endCardsPos = HOLD + (cards.length - 1) * STEP + CARD_DUR;
    tl.to(footer, { opacity: 1, y: 0, duration: 0.10, ease: 'none' }, endCardsPos);

    // ホールド（2〜3 スクロール分の余韻）
    const GAP_AFTER = 1.5;
    tl.to({}, { duration: GAP_AFTER }, endCardsPos + 0.10);

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: '+=3000',
      pin: true,
      scrub: 1.5,
      animation: tl,
    });

    return () => {
      gsap.set([headerInner, headerLine, ...cards, footer].filter(Boolean), {
        clearProps: 'all',
        willChange: 'auto',
      });
    };
  });

  // ── モバイル：ピン留め + スクラブ（PC と同じ動き）──
  mm.add('(max-width: 991px)', () => {
    const HOLD     = 0.10;
    const STEP     = 0.20;
    const CARD_DUR = 0.16;

    const tl = gsap.timeline({ paused: true });

    gsap.set([headerInner, headerLine, ...cards, footer].filter(Boolean), {
      willChange: 'transform, opacity, clip-path',
    });
    gsap.set(headerInner, { x: -50, opacity: 0 });
    gsap.set(headerLine,  { scaleX: 0 });
    gsap.set(cards,       { clipPath: 'inset(100% 0 0% 0)', opacity: 0 });
    gsap.set(footer,      { opacity: 0, y: 16 });

    tl.to(headerInner, { x: 0, opacity: 1, duration: 0.10, ease: 'none' }, 0);
    tl.to(headerLine,  { scaleX: 1, duration: 0.08, ease: 'none' }, 0.06);

    cards.forEach((card, i) => {
      tl.to(
        card,
        { clipPath: 'inset(0% 0 0% 0)', opacity: 1, duration: CARD_DUR, ease: 'none' },
        HOLD + i * STEP,
      );
    });

    const endCardsPos = HOLD + (cards.length - 1) * STEP + CARD_DUR;
    tl.to(footer, { opacity: 1, y: 0, duration: 0.10, ease: 'none' }, endCardsPos);

    const GAP_AFTER = 1.0;
    tl.to({}, { duration: GAP_AFTER }, endCardsPos + 0.10);

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: '+=2000',
      pin: true,
      scrub: 1.5,
      animation: tl,
    });

    return () => {
      gsap.set([headerInner, headerLine, ...cards, footer].filter(Boolean), {
        clearProps: 'all',
        willChange: 'auto',
      });
    };
  });
};

// ============================================================
// RECRUIT セクション
// ============================================================
const initRecruit = () => {
  const section = document.querySelector('.p-top-recruit');
  if (!section) return;

  const content  = section.querySelector('.p-top-recruit__content');
  const imageCol = section.querySelector('.p-top-recruit__image-col');

  // テキスト：右からスライドイン（scrub）
  gsap.fromTo(
    content,
    { x: 80, opacity: 0 },
    {
      x: 0, opacity: 1, ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 88%',
        end: 'top 32%',
        scrub: 1,
      },
    }
  );

  // 写真：左からスライドイン（scrub）
  gsap.fromTo(
    imageCol,
    { x: -80, opacity: 0 },
    {
      x: 0, opacity: 1, ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 88%',
        end: 'top 32%',
        scrub: 1,
      },
    }
  );
};

// ============================================================
// NEWS セクション
// ============================================================
const initNews = () => {
  const section = document.querySelector('.p-top-news');
  if (!section) return;

  const headerInner = section.querySelector('.p-top-news__header-inner');
  const headerLine  = section.querySelector('.p-top-news__header-line');
  const cards       = Array.from(section.querySelectorAll('.p-top-news__card'));
  const footer      = section.querySelector('.p-top-news__footer');

  // ヘッダー：左からスライドイン（scrub）
  gsap.fromTo(
    headerInner,
    { x: -60, opacity: 0 },
    {
      x: 0, opacity: 1, ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 88%',
        end: 'top 58%',
        scrub: 1,
      },
    }
  );

  // HUD ライン
  if (headerLine) {
    gsap.fromTo(
      headerLine,
      { scaleX: 0 },
      {
        scaleX: 1, ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top 85%',
          end: 'top 50%',
          scrub: 1,
        },
      }
    );
  }

  // カード：左から順番にフェードイン（scrub + stagger 的に start をずらす）
  gsap.set(cards, { willChange: 'transform, opacity' });
  cards.forEach((card, i) => {
    const offset = i * 5; // カードごとに5%ずつ遅らせる
    gsap.fromTo(
      card,
      { x: -50, opacity: 0 },
      {
        x: 0, opacity: 1, ease: 'none',
        scrollTrigger: {
          trigger: section.querySelector('.p-top-news__list-wrap'),
          start: `top ${88 - offset}%`,
          end:   `top ${40 - offset}%`,
          scrub: 1,
        },
      }
    );
  });

  // フッター
  if (footer) {
    gsap.fromTo(
      footer,
      { opacity: 0, y: 20 },
      {
        opacity: 1, y: 0, ease: 'none',
        scrollTrigger: {
          trigger: footer,
          start: 'top 92%',
          end: 'top 68%',
          scrub: 1,
        },
      }
    );
  }
};

// ============================================================
// CONTACT セクション
// ============================================================
const initContact = () => {
  const section = document.querySelector('.p-top-contact');
  if (!section) return;

  const catchEl = section.querySelector('.p-top-contact__catch');
  const subEl   = section.querySelector('.p-top-contact__sub');
  const ctaEl   = section.querySelector('.p-top-contact__cta');
  const beeEl   = section.querySelector('.p-top-contact__bee');

  // キャッチコピーを1文字ずつ span に分解
  if (catchEl && !catchEl.dataset.split) {
    catchEl.dataset.split = '1';
    catchEl.innerHTML = catchEl.textContent.split('').map(char =>
      char === ' '
        ? '<span style="display:inline-block;width:0.28em"> </span>'
        : `<span style="display:inline-block">${char}</span>`
    ).join('');
  }

  const chars = Array.from(catchEl.querySelectorAll('span'));
  gsap.set(chars, { opacity: 0, x: -16 });

  // 文字：左から順番にスクラブ
  gsap.to(chars, {
    opacity: 1, x: 0, ease: 'none',
    stagger: 0.04,
    scrollTrigger: {
      trigger: section,
      start: 'top 80%',
      end: 'top 15%',
      scrub: 1,
    },
  });

  // サブコピー + CTA：フェードアップ（scrub）
  [subEl, ctaEl].filter(Boolean).forEach((el, i) => {
    gsap.fromTo(
      el,
      { opacity: 0, y: 30 },
      {
        opacity: 1, y: 0, ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: `top ${62 - i * 12}%`,
          end:   `top ${20 - i * 8}%`,
          scrub: 1,
        },
      }
    );
  });

  // B案：常時浮遊 + CONTACT 接近で定位置へ着地
  if (beeEl) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // CSS 定位置: right:27%, bottom:55%
    // 定位置でのビューポート内座標（蜂の左上角）
    const beeW   = beeEl.offsetWidth  || 90;
    const beeH   = beeEl.offsetHeight || 90;
    const pad    = 24; // 画面端からの余白(px)

    // x:0, y:0 のときの left/top（CSSの right/bottom から逆算）
    const anchorLeft = vw * (1 - 0.27) - beeW;
    const anchorTop  = vh * (1 - 0.55) - beeH;

    // 画面内に収まる x/y オフセットの範囲
    const minX = -(anchorLeft - pad);
    const maxX =  vw - pad - beeW - anchorLeft;
    const minY = -(anchorTop  - pad);
    const maxY =  vh - pad - beeH  - anchorTop;

    let wanderTween = null;
    let isLanded    = false;

    const nextWander = () => {
      if (isLanded) return;
      const x = gsap.utils.random(minX, maxX);
      const y = gsap.utils.random(minY, maxY);
      wanderTween = gsap.to(beeEl, {
        x, y,
        duration: gsap.utils.random(3.0, 5.5),
        ease: 'power1.inOut',
        onComplete: nextWander,
      });
    };

    // 攻撃されて撃墜後の復活（beamShoot.js から bee:revive イベントを受信）
    beeEl.addEventListener('bee:revive', () => {
      gsap.set(beeEl, { display: '', opacity: 0, x: -window.innerWidth * 0.6, y: 0, scale: 1 });
      gsap.to(beeEl, {
        x: 0,
        opacity: 1,
        duration: 1.4,
        ease: 'power3.out',
        onComplete: () => {
          isLanded = false;
          nextWander();
        },
      });
    });

    // ページ表示後 1.2s でフェードイン & 浮遊開始（画面中央あたりから）
    gsap.set(beeEl, { opacity: 0, x: minX * 0.5, y: minY * 0.5 });
    gsap.to(beeEl, {
      opacity: 1,
      duration: 1.0,
      delay: 1.2,
      ease: 'power2.out',
      onComplete: nextWander,
    });

    // CONTACT セクション接近 → 浮遊を止めて定位置へ滑らかに誘導
    ScrollTrigger.create({
      trigger: section,
      start: 'top 85%',
      onEnter: () => {
        isLanded = true;
        if (wanderTween) wanderTween.kill();
        gsap.to(beeEl, {
          x: 0, y: 0,
          duration: 2.2,
          ease: 'power2.inOut',
          onComplete: () => beeEl.classList.add('is-landed'),
        });
      },
      onLeaveBack: () => {
        isLanded = false;
        beeEl.classList.remove('is-landed');
        nextWander();
      },
    });
  }
};

// ============================================================
// 固定動画背景（WORKS セクション通過後に表示）
// ============================================================
const initBgVideo = () => {
  const wrap = document.getElementById('js-bg-video-wrap');
  if (!wrap) return;

  ScrollTrigger.create({
    trigger: '.p-top-works',
    start: 'top bottom',
    end: 'bottom bottom',
    onEnter:     () => wrap.classList.add('is-active'),
    onLeaveBack: () => wrap.classList.remove('is-active'),
  });
};

// ============================================================
// 初期化
// ============================================================
const init = () => {
  initAbout();
  initService();
  initWorks();
  initBgVideo();
  initRecruit();
  initNews();
  initContact();
};

export default { init };
